import { cdnOrigin, s3Origin, s3BucketName, cdnFullURL } from "../enums/constants"

export const cdnToS3URLChanger = (cdnURL: string): string => {
    return cdnURL.replace(cdnOrigin, s3Origin)
}

export const cdnToS3BucketNameChanger = (cdnURL: string): string => {
    return cdnURL.replace(cdnFullURL, s3BucketName)
}